<template>
  <VueperSlides
    autoplay
    class="no-shadow"
    :visible-slides="3"
    :breakpoints="breakpoints"
    :touchable="false"
    fixed-height="350px"
    duration="10000"
    :dragging-distance="20"
  >
    <VueperSlide
      v-for="(slide, index) in slides"
      :key="'review_'+index"
    >
      <template #content>
        <div class="box_how mr-3 ml-3">
          <img
            class="align-middle img-fluid mb-4"
            :src="slide.img"
            :alt="slide.title"
            :title="slide.title"
            height="200"
            width="200"
            style="height: 200px; max-width: 70%; width: auto;"
          >
          <h4>{{ slide.title }}</h4>
          <p>{{ slide.text }}</p>
        </div>
      </template>
    </vueperslide>
  </vueperslides>
</template>
<script>
import { VueperSlide, VueperSlides } from 'vueperslides';

export default {
  name: 'HowWorksCarousel',
  components: {
    VueperSlides,
    VueperSlide,
  },

  data() {
    return {
      breakpoints:
          {
            992: { // menor a 768 large
              visibleSlides: 1,
              slideMultiple: 1,
              arrows: true,
              bulletsOutside: true,
              touchable: true,
              fixedHeight: '350px',
            },
          },
    };
  },

  computed: {
    slides() {
      const slide = [
        {
          img: require('../../assets/img/illustrations/search-stores.svg'),
          title: this.$t('lang.home.how_works.step1_title'),
          text: this.$t('lang.home.how_works.step1'),
        },
        {
          img: require('../../assets/img/illustrations/leave-luggage.svg'),
          title: this.$t('lang.home.how_works.step2_title'),
          text: this.$t('lang.home.how_works.step2'),
        },
        {
          img: require('../../assets/img/illustrations/enjoy.svg'),
          title: this.$t('lang.home.how_works.step3_title'),
          text: this.$t('lang.home.how_works.step3'),
        },
      ];
      return slide;
    },
  },
};
</script>

<style scoped>
</style>
